import {Breadcrumb, Button, Card, Form, InputNumber, Modal, Result, Select, Tabs, Tooltip} from "antd";
import {InfoCircleOutlined} from '@ant-design/icons';
import {Link, useParams} from "react-router-dom";
import {Customer, Device} from "../core/datamodel";
import {del, get, post} from "../core/request";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../store";
import {ViewState} from "../states";
import Loading from "../components/loading";
import {ApiTable} from "../components/table";
import {IconSet} from "../components/icons";
import {triggerReload} from "../reducers/reloadsignal-reducer";
import CustomSelect from "../components/select";

function ColumMappingEditor(props: {
    device: Device,
    path: string,
    title: string,
}) {
    const [headerState, setHeaderState] = useState(ViewState.loading);
    const [headerData, setHeaderData] = useState({} as any);
    const [form] = Form.useForm();
    const [factorEnabled, setFactorEnabled] = useState(false);
    const [factorHelp, setFactorHelp] = useState("");

    const reloadSignal = useAppSelector(state => state.reloadSignals.device)
    let dispatch = useAppDispatch();

    useEffect(() => {
        get("devices/" + props.device.props.uuid + "/" + props.path + "/options").done((response) => {
                setHeaderData(response.data);
                setHeaderState(ViewState.success);
            }
        ).fail(() => setHeaderState(ViewState.failed))

    }, [props.device, props.path, reloadSignal])

    const addmapping = (values: any) => {
        post(props.path, {
            device: {uuid: props.device.props.uuid},
            source: values.quelle,
            target: values.ziel,
            factor: values.factor
        }).then(() => {
            form.resetFields()
        }).fail((resp: any) => {
            Modal.error({
                title: "Fehler",
                content: resp?.responseJSON?.data?.description ? resp.responseJSON.data.description : "Die Spalten-Zuordnung konnte nicht hinzugefügt werden."
            })
        })
    }

    const factor_available = (value: any) => {
        console.log(headerData["numeric_cols"].includes(value))
        if (headerData["numeric_cols"].includes(value)) {
            setFactorEnabled(true);
            setFactorHelp("(optional) Faktor für eine manuelle Anpassung der Einheit")
        } else {
            setFactorEnabled(false);
            setFactorHelp("Der Faktor ist für dieses Ziel nicht verfügbar")
        }
    }

    const pageHeader = (
        <Card
            type="inner"
            //title={props.device?.props?.name ? <>Neue manuelle Zuordnung für {props.device.props.name}</> : "Neue Zuordnung"}
        >
            {
                headerState === ViewState.success ?
                    <Form
                        form={form}
                        layout="inline"
                        onFinish={addmapping}
                        style={{display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center', justifyContent: 'flex-start'}}
                    >
                        <Form.Item label="Quelle" name="quelle" rules={[{required: true}]} style={{width: '27%'}}>
                            <CustomSelect searchable style={{width: '100%'}}>
                                {headerData.sources ? headerData.sources.map((source: any) => (
                                    <Select.Option key={source} value={source}>{source}</Select.Option>
                                )) : <></>}
                            </CustomSelect>
                        </Form.Item>
                        <Form.Item label="Ziel" name="ziel" rules={[{required: true}]} style={{width: '27%'}}>
                            <CustomSelect searchable onChange={factor_available} style={{width: '100%'}}>
                                {headerData.targets ? Object.keys(headerData.targets).map(target => (
                                    <Select.Option
                                        key={target}
                                        value={target}
                                    >
                                        {headerData.targets[target]}
                                    </Select.Option>
                                )) : <></>}
                            </CustomSelect>
                        </Form.Item>
                        <Form.Item
                            label={
                                <>
                                    Faktor&nbsp;
                                    <Tooltip title={factorHelp}>
                                        <InfoCircleOutlined />
                                    </Tooltip>
                                </>
                            }
                            name="factor"
                            style={{width: '27%'}}
                        >
                                <InputNumber
                                    style={{width: '100%',flex: 1}}
                                    disabled={!factorEnabled}
                                    decimalSeparator=","
                                    addonBefore="x"
                                    placeholder={"Faktor wird entfernt wenn leer"}
                                    min={0}
                                />
                        </Form.Item>

                        <Button type="primary" htmlType="submit" style={{marginLeft: 'auto'}} >Hinzufügen</Button>

                    </Form> : <>
                        {headerState === ViewState.loading ? <Loading/> : <>Sie haben keine Berechtigung dieses Mapping zu
                            bearbeiten. Bitte wenden Sie sich an einen Administrator.</>}
                    </>
            }
        </Card>
    )

    const pageBody = (
        <ApiTable
            title={<>aktuelle Spalten-Zuordung</>}
            id="Device_ColumnMapping"
            url={"devices/" + props.device?.props?.uuid + "/" + props.path}
            reloadSignals={[useAppSelector(state => state.reloadSignals.columnMapping)]}
            searchable
            heightReducer={48 + 34 + 45 + 16 + 56 + 24+ 64 +24 + 56 + 24 + 24 + 65 + 55}
            actionWidth={50}
            actions={(text: any, row: any) => (
                // roww key starts with "Default_" are not deletable
                row?.key && !row.key.startsWith("Default_") && !row.key.startsWith("Unused_") ?
                    <Tooltip overlay={"Zuordnung löschen"}>
                        <IconSet
                            type='delete'
                            //@ts-ignore
                            className="action-delete"
                            //@ts-ignore
                            onClick={() => {
                                Modal.confirm({
                                    title: "Zuordnung löschen",
                                    content: "Soll die Zuordnung '" + row.quelle + "' -> '" + row.ziel + "' wirklich gelöscht werden?",
                                    maskClosable: true,
                                    cancelText: 'Abbrechen',
                                    okText: 'Löschen',
                                    okType: 'danger',
                                    autoFocusButton: 'cancel',
                                    onOk: () => {
                                        del(props.path + "/" + row.key).then(() => {
                                                dispatch(triggerReload('columnMapping'))
                                            }
                                        )
                                    }
                                });

                                return true;
                            }}
                        />
                    </Tooltip> : <></>
            )}
        />
    )

    return (
        <>
            <Card
                title={props.title}
            >
                {pageHeader}
                <br/>
                {pageBody}
            </Card>

        </>
    )
}

export default function DeviceColumnMappingView(props: any) {
    const params: { id: string } = useParams();
    const reloadSignal = useAppSelector(state => state.reloadSignals.device)
    const [device, setDevice] = useState({} as Device);
    const [state, setState] = useState(ViewState.loading);

    const [customer, setCustomer] = useState({} as Customer);
    const customerReloadSignal = useAppSelector(state => state.reloadSignals.customer)


    useEffect(() => {
        get("devices/" + params.id).done((response) => {
                setDevice(new Device(response.data.device));
                setState(ViewState.success);
            }
        ).fail(() => setState(ViewState.failed))

    }, [params.id, reloadSignal])

    useEffect(() => {
        if (!!device?.props?.customer?.props?.uuid) {
            get("customers/" + device.props.customer.props.uuid).done(
                (response) => {
                    setCustomer(new Customer(response.data.customer));
                }
            )
        }
    }, [device?.props?.customer, customerReloadSignal])


    const breadcrumb = (
        <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link to="/customers">Kunden</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link
                to={"/customers/" + customer.props?.uuid}>{!!customer.props?.repr ? customer.props.repr : "Unknown"}</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link
                to={"/devices/" + params.id}>{!!device?.props?.name ? device.props.name : "Unknown"}</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Spalten-Zuordnung</Breadcrumb.Item>
        </Breadcrumb>
    )

    const editor = (
        <Tabs
            defaultActiveKey="1"
            items={
                [
                    {
                        key: "data",
                        label: "Daten-Upload",
                        children: <ColumMappingEditor device={device} path={"columnmappings_data"} title={"Daten-Zuordnung"}/>
                    },
                    {
                        disabled: !device?.props?.has_mappings,
                        key: "drw",
                        label: "Mapping-Upload",
                        children: <ColumMappingEditor device={device} path={"columnmappings_drwmappings"} title={"Mapping-Zuornung"}/>
                    },
                ]
            }
            />
    )

    switch (state) {
        case ViewState.loading:
            return (
                <>
                    {breadcrumb}
                    <Loading/>
                </>
            )
        case ViewState.success:
            return (
                <>
                    {breadcrumb}
                    {editor}
                </>
            )

        case ViewState.failed:
        default:
            return (
                <>
                    {breadcrumb}
                    <Result
                        status="500"
                        title="Es ist ein Fehler aufgetreten."
                        subTitle="Bitte versuchen Sie es später erneut."
                    />
                </>
            )
    }
}